module.exports = __webpack_public_path__ + "static/media/outline-icons.ef60a4f6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/outline-icons.woff
// module id = ./src/styling/theme/assets/fonts/outline-icons.woff
// module chunks = 0